import { Link } from "react-router-dom";
import { useFyaiConfig } from "@/hooks/useFyaiConfig";
import { fyaiLogo } from "@/mocks/fyai-data";

type FyaiFooterProps = {
  isHome?: boolean;
};

const productLinks = [
  { label: "功能特色", href: "#features" },
  { label: "AI角色", href: "#characters" },
  { label: "软件截图", href: "#screenshots" },
  { label: "常见问题", href: "#faq" },
];

export default function FyaiFooter({ isHome = true }: FyaiFooterProps) {
  const config = useFyaiConfig();

  return (
    <footer className="w-full bg-primary-950">
      <div className="grid w-full grid-cols-1 gap-8 px-4 py-12 md:px-6 md:py-16 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-lg">
              <img src={fyaiLogo} alt="风月AIlogo" title="风月AI官网" className="h-full w-full object-cover" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">风月AI</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-primary-200">
            风月AI聊天软件，AI风月情感陪伴。在这里，遇见属于你的故事，与TA对话，开启另一种人生。
          </p>
          <p className="mt-4 text-sm font-medium text-accent-400">{config.domain}</p>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-base font-bold text-background-50">
            <a href={isHome ? "#top" : "#"} className="cursor-default">产品功能</a>
          </h4>
          <ul className="flex flex-col gap-3">
            {productLinks.map((item) =>
              isHome ? (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-primary-200 transition-colors hover:text-background-50">
                    {item.label}
                  </a>
                </li>
              ) : (
                <li key={item.href}>
                  <Link to="/" className="text-sm text-primary-200 transition-colors hover:text-background-50">
                    {item.label}
                  </Link>
                </li>
              ),
            )}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-base font-bold text-background-50">
            <a href={isHome ? "#download-tip" : "#"} className="cursor-default">下载与支持</a>
          </h4>
          <ul className="flex flex-col gap-3">
            <li>
              <Link to="/download" className="text-sm text-primary-200 transition-colors hover:text-background-50">
                风月AI官网下载
              </Link>
            </li>
            <li>
              <span className="text-sm text-primary-200">
                Android / iOS / HarmonyOS / Windows
              </span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-base font-bold text-background-50">联系我们</h4>
          <p className="mb-2 text-sm text-primary-200">官方联系邮箱</p>
          <p className="mb-4 text-sm font-medium text-accent-400">{config.contactEmail}</p>
          <a
            href={config.officialUrl}
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-600"
          >
            <i className="ri-external-link-line" />
            访问官网
          </a>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="flex w-full flex-col items-center justify-between gap-3 px-4 py-6 md:flex-row md:px-6">
          <p className="text-xs text-primary-300">
            © {new Date().getFullYear()} 风月AI · 风月AI官网 · 保留所有权利
          </p>
          <p className="text-xs text-primary-300">AI风月 · 风月AI聊天软件 · 风月AI官网下载</p>
        </div>
      </div>
    </footer>
  );
}